// @ts-nocheck
// TODO: tighten types after migration
// Collection schema definitions for BlogDb collections
// This defines the structure and required fields for each collection

export const COLLECTION_SCHEMAS = {
    BlogContent: {
        requiredFields: ['postNumber', 'title', 'description', 'slug', 'seoKeywords', 'author', 'coverImage', 'content', 'isPublished', 'category', 'postTopic'],
        // Field order for display (excluding _id which is always first)
        fieldOrder: ['postNumber', 'title', 'seoTitle', 'description', 'seoDescription', 'slug', 'seoKeywords', 'author', 'coverImage', 'thumbnailCopyright', 'content', 'isPublished', 'category', 'postTopic', 'createdAt', 'publishedAt', 'publishedBy', 'noIndex', 'priorityPost', 'emailNotification'],
        fieldTypes: {
            postNumber: 'number',
            title: 'string',
            seoTitle: 'string',
            description: 'string',
            seoDescription: 'string',
            slug: 'string',
            seoKeywords: 'array',
            author: 'array',
            coverImage: 'object',
            thumbnailCopyright: 'string',
            content: 'richtext',
            isPublished: 'boolean',
            category: 'object',
            postTopic: 'object',
            createdAt: 'date',
            publishedAt: 'date',
            publishedBy: 'string',
            noIndex: 'boolean',
            priorityPost: 'boolean',
            emailNotification: 'object'
        },
        fieldLabels: {
            postNumber: 'Post Number',
            title: 'Title',
            seoTitle: 'SEO Title',
            description: 'Description',
            seoDescription: 'SEO Description',
            slug: 'Slug',
            seoKeywords: 'SEO Keywords',
            author: 'Author',
            coverImage: 'Cover Image',
            thumbnailCopyright: 'Thumbnail Copyright',
            content: 'Content',
            isPublished: 'Is Published',
            category: 'Category',
            postTopic: 'Post Topic',
            createdAt: 'Created At',
            publishedAt: 'Published At',
            publishedBy: 'Published By (User ID)',
            noIndex: 'No Index',
            priorityPost: 'Priority Post',
            emailNotification: 'Email Sent'
        }
    },
    AuthorDetails: {
        requiredFields: ['authorNumber', 'name', 'bio', 'image'],
        fieldOrder: ['authorNumber', 'name', 'bio', 'image', 'seoTitle', 'seoDescription', 'socialLinks'],
        fieldTypes: {
            authorNumber: 'number',
            name: 'string',
            bio: 'string',
            image: 'object',
            seoTitle: 'string',
            seoDescription: 'string',
            socialLinks: 'array'
        },
        fieldLabels: {
            authorNumber: 'Author Number',
            name: 'Name',
            bio: 'Bio',
            image: 'Image',
            seoTitle: 'SEO Title',
            seoDescription: 'SEO Description',
            socialLinks: 'Social Links'
        }
    },
    Category: {
        requiredFields: ['name', 'slug', 'seoTitle', 'seoDescription'],
        fieldOrder: ['name', 'slug', 'seoTitle', 'seoDescription', 'seoKeywords'],
        fieldTypes: {
            name: 'string',
            slug: 'string',
            seoTitle: 'string',
            seoDescription: 'string',
            seoKeywords: 'array'
        },
        fieldLabels: {
            name: 'Name',
            slug: 'Slug',
            seoTitle: 'SEO Title',
            seoDescription: 'SEO Description',
            seoKeywords: 'SEO Keywords'
        }
    },
    PostTopics: {
        requiredFields: ['topic', 'topicSlug'],
        fieldOrder: ['topic', 'topicSlug', 'whichCategory'],
        fieldTypes: {
            topic: 'string',
            topicSlug: 'string',
            whichCategory: 'objectid'
        },
        fieldLabels: {
            topic: 'Topic',
            topicSlug: 'Topic Slug',
            whichCategory: 'Which Category'
        }
    },
    // BlogDb - ImageAssets collection
    ImageAssets: {
        requiredFields: ['fileName', 'url'],
        fieldOrder: ['fileName', 'url', 'altText', 'title'],
        fieldTypes: {
            fileName: 'string',
            url: 'string',
            altText: 'string',
            title: 'string',
            uploadedAt: 'date'
        },
        fieldLabels: {
            fileName: 'File Name',
            url: 'URL',
            altText: 'Alt Text',
            title: 'Title',
            uploadedAt: 'Uploaded At'
        }
    },
    // CredDb - Users collection
    Users: {
        requiredFields: ['name', 'email', 'isSubscribed'],
        fieldOrder: ['name', 'email', 'profileImage', 'role', 'isSubscribed', 'createdAt'],
        fieldTypes: {
            name: 'string',
            email: 'string',
            passwordHash: 'string',
            profileImage: 'string',
            role: 'enum',
            isSubscribed: 'boolean',
            createdAt: 'date'
        },
        fieldLabels: {
            name: 'Name',
            email: 'Email',
            passwordHash: 'Password Hash',
            profileImage: 'Profile Image',
            role: 'Role',
            isSubscribed: 'Is Subscribed',
            createdAt: 'Created At'
        }
    },
    // NewsLetterDb - UserEmails collection
    UserEmails: {
        requiredFields: ['email'],
        fieldOrder: ['email', 'createdAt'],
        fieldTypes: {
            email: 'string',
            createdAt: 'date'
        },
        fieldLabels: {
            email: 'Email',
            createdAt: 'Created At'
        }
    },
    // PodcastDb - PodcastGuests collection
    PodcastGuests: {
        requiredFields: ['name', 'guestNumber'],
        fieldOrder: ['name', 'guestNumber', 'guestType', 'email', 'image', 'socialLinks'],
        fieldTypes: {
            name: 'string',
            guestNumber: 'number',
            guestType: 'enum',
            email: 'string',
            image: 'string',
            socialLinks: 'array'
        },
        fieldLabels: {
            name: 'Name',
            guestNumber: 'Guest Number',
            guestType: 'Guest Type',
            email: 'Email',
            image: 'Image',
            socialLinks: 'Social Links'
        }
    },
    // PodcastDb - PodcastsAudioDetails collection
    PodcastsAudioDetails: {
        requiredFields: ['title', 'slug', 'audioFile', 'date', 'description', 'hosts', 'thumbnail', 'featured', 'podcastNumber'],
        fieldOrder: ['podcastNumber', 'title', 'seoTitle', 'description', 'seoDescription', 'slug', 'seoKeywords', 'overview', 'date', 'isPublished', 'hosts', 'thumbnail', 'audioFile', 'episodeLinks', 'featured', 'transcript', 'emailNotification'],
        fieldTypes: {
            title: 'string',
            slug: 'string',
            seoTitle: 'string',
            audioFile: 'string',
            date: 'date',
            description: 'string',
            overview: 'richtext',
            seoDescription: 'string',
            seoKeywords: 'array',
            isPublished: 'boolean',
            hosts: 'array',
            thumbnail: 'string',
            featured: 'boolean',
            podcastNumber: 'number',
            episodeLinks: 'array',
            transcript: 'array',
            emailNotification: 'object'
        },
        fieldLabels: {
            title: 'Title',
            slug: 'Slug',
            seoTitle: 'SEO Title',
            audioFile: 'Audio File',
            date: 'Date',
            description: 'Description',
            overview: 'Overview',
            seoDescription: 'SEO Description',
            seoKeywords: 'SEO Keywords',
            isPublished: 'Is Published',
            hosts: 'Hosts',
            thumbnail: 'Thumbnail',
            featured: 'Featured',
            podcastNumber: 'Podcast Number',
            episodeLinks: 'Episode Links',
            transcript: 'Transcript',
            emailNotification: 'Email Sent'
        }
    },
    // SponsorshipDb - AdPromotions collection
    AdPromotions: {
        requiredFields: ['companyName', 'productName', 'promotionLink', 'startDate', 'endDate', 'image'],
        fieldOrder: ['companyName', 'productName', 'promotionLink', 'startDate', 'endDate', 'image'],
        fieldTypes: {
            companyName: 'string',
            productName: 'string',
            promotionLink: 'string',
            startDate: 'date',
            endDate: 'date',
            image: 'array'
        },
        fieldLabels: {
            companyName: 'Company Name',
            productName: 'Product Name',
            promotionLink: 'Promotion Link',
            startDate: 'Start Date',
            endDate: 'End Date',
            image: 'Image'
        }
    },
    // SponsorshipDb - BrandSponsorship collection
    BrandSponsorship: {
        requiredFields: ['brandName', 'Logo', 'Link', 'startDate', 'endDate', 'altText'],
        fieldOrder: ['brandName', 'Logo', 'Link', 'startDate', 'endDate', 'altText'],
        fieldTypes: {
            brandName: 'string',
            Logo: 'string',
            Link: 'string',
            startDate: 'date',
            endDate: 'date',
            altText: 'string'
        },
        fieldLabels: {
            brandName: 'Brand Name',
            Logo: 'Logo',
            Link: 'Link',
            startDate: 'Start Date',
            endDate: 'End Date',
            altText: 'Alt Text'
        }
    },
    // StoreDb - ProductDetails collection
    ProductDetails: {
        requiredFields: ['title', 'slug', 'category', 'brand', 'sku', 'tags', 'description', 'canPurchase', 'isVisible', 'productType'],
        fieldOrder: ['title', 'slug', 'category', 'brand', 'sku', 'variants', 'tags', 'description', 'whatsInTheBox', 'images', 'displayImage', 'productType', 'stockAvailability', 'createdAt', 'updatedAt', 'canPurchase', 'isVisible'],
        fieldTypes: {
            title: 'string',
            slug: 'string',
            category: 'string',
            brand: 'string',
            sku: 'string',
            variants: 'array',
            tags: 'array',
            description: 'richtext',
            whatsInTheBox: 'object',
            images: 'array',
            displayImage: 'array',
            productType: 'enum',
            stockAvailability: 'number',
            createdAt: 'date',
            updatedAt: 'date',
            canPurchase: 'boolean',
            isVisible: 'boolean'
        },
        fieldLabels: {
            title: 'Title',
            slug: 'Slug',
            category: 'Category',
            brand: 'Brand',
            sku: 'SKU',
            variants: 'Variants',
            tags: 'Tags',
            description: 'Description',
            whatsInTheBox: "What's in the Box",
            images: 'Images',
            displayImage: 'Display Images (Digital Products Only)',
            productType: 'Product Type',
            stockAvailability: 'Stock Availability',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            canPurchase: 'Can Purchase',
            isVisible: 'Is Visible'
        }
    },
    // StoreDb - PurchaseOrders collection
    PurchaseOrders: {
        requiredFields: ['email', 'shippingAddress', 'billingAddress', 'products', 'totalAmount', 'payment', 'orderStatus', 'shipping', 'createdAt', 'updatedAt'],
        fieldOrder: ['userId', 'email', 'contactNumber', 'shippingAddress', 'billingAddress', 'products', 'totalAmount', 'payment', 'orderStatus', 'shipping', 'createdAt', 'updatedAt'],
        // Note: shipping is a nested object with required sub-fields
        fieldTypes: {
            userId: 'string',
            email: 'string',
            contactNumber: 'string',
            shippingAddress: 'object',
            billingAddress: 'object',
            products: 'array',
            totalAmount: 'number',
            payment: 'object',
            orderStatus: 'enum',
            shipping: 'object',
            createdAt: 'date',
            updatedAt: 'date'
        },
        fieldLabels: {
            userId: 'User ID',
            email: 'Email',
            contactNumber: 'Contact Number',
            shippingAddress: 'Shipping Address',
            billingAddress: 'Billing Address',
            products: 'Products',
            totalAmount: 'Total Amount',
            payment: 'Payment',
            orderStatus: 'Order Status',
            shipping: 'Shipping',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
        }
    },
    // StoreDb - CouponCode collection
    CouponCode: {
        requiredFields: ['name', 'id', 'code', 'discountType', 'offerStartDate', 'offerEndDate', 'offerIsVisible'],
        fieldOrder: ['name', 'id', 'description', 'code', 'product', 'discountType', 'discountValue', 'discountByCountry', 'minimumOrderValue', 'minimumOrderValueByCountry', 'offerStartDate', 'offerEndDate', 'offerIsVisible', 'isActive', 'createdAt', 'updatedAt'],
        fieldTypes: {
            name: 'string',
            id: 'string',
            description: 'richtext',
            code: 'string',
            product: 'productarray',
            discountType: 'enum',
            discountValue: 'number',
            discountByCountry: 'array',
            minimumOrderValue: 'number',
            minimumOrderValueByCountry: 'array',
            offerStartDate: 'date',
            offerEndDate: 'date',
            offerIsVisible: 'boolean',
            isActive: 'boolean',
            createdAt: 'date',
            updatedAt: 'date'
        },
        fieldLabels: {
            name: 'Name',
            id: 'ID',
            description: 'Description',
            code: 'Code',
            product: 'Applicable Products',
            discountType: 'Discount Type',
            discountValue: 'Discount Value (%)',
            discountByCountry: 'Discount By Country (Fixed)',
            minimumOrderValue: 'Minimum Order Value',
            minimumOrderValueByCountry: 'Minimum Order Value By Country',
            offerStartDate: 'Offer Start Date',
            offerEndDate: 'Offer End Date',
            offerIsVisible: 'Offer Is Visible',
            isActive: 'Is Active',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
        }
    },
    // StoreDb - Regions collection (Multi-region support)
    Regions: {
        requiredFields: ['code', 'name', 'currency', 'currencySymbol', 'paymentMode', 'isActive'],
        fieldOrder: ['code', 'name', 'currency', 'currencySymbol', 'paymentMode', 'isActive', 'createdAt', 'updatedAt'],
        fieldTypes: {
            code: 'string',
            name: 'string',
            currency: 'string',
            currencySymbol: 'string',
            paymentMode: 'enum',
            isActive: 'boolean',
            createdAt: 'date',
            updatedAt: 'date'
        },
        fieldLabels: {
            code: 'Country Code (ISO)',
            name: 'Region Name',
            currency: 'Currency Code',
            currencySymbol: 'Currency Symbol',
            paymentMode: 'Payment Mode',
            isActive: 'Is Active',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
        }
    },
    // StoreDb - ProductPrices collection (Multi-country pricing engine)
    ProductPrices: {
        requiredFields: ['productId', 'countryCode', 'currency', 'basePrice', 'offerPrice', 'taxIncluded', 'isActive'],
        fieldOrder: ['productId', 'countryCode', 'currency', 'basePrice', 'offerPrice', 'taxIncluded', 'isActive', 'createdAt', 'updatedAt'],
        fieldTypes: {
            productId: 'objectid',
            countryCode: 'string',
            currency: 'string',
            basePrice: 'number',
            offerPrice: 'number',
            taxIncluded: 'boolean',
            isActive: 'boolean',
            createdAt: 'date',
            updatedAt: 'date'
        },
        fieldLabels: {
            productId: 'Product',
            countryCode: 'Country Code',
            currency: 'Currency',
            basePrice: 'Base Price (MRP)',
            offerPrice: 'Offer Price',
            taxIncluded: 'Tax Included',
            isActive: 'Is Active',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
        }
    },
    // StoreDb - StoreEmailLogs collection
    StoreEmailLogs: {
        requiredFields: ['orderId', 'emailType', 'recipientEmail', 'status'],
        fieldOrder: ['orderId', 'emailType', 'recipientEmail', 'status', 'provider', 'sentAt', 'errorMessage', 'createdAt'],
        fieldTypes: {
            orderId: 'string',
            emailType: 'string',
            recipientEmail: 'string',
            status: 'enum',
            provider: 'string',
            providerMessageId: 'string',
            errorMessage: 'string',
            sentAt: 'date',
            createdAt: 'date'
        },
        fieldLabels: {
            orderId: 'Order ID',
            emailType: 'Email Type',
            recipientEmail: 'Recipient',
            status: 'Status',
            provider: 'Provider',
            providerMessageId: 'Message ID',
            errorMessage: 'Error',
            sentAt: 'Sent At',
            createdAt: 'Created At'
        }
    },
    // StoreDb - EmailTemplates collection
    EmailTemplates: {
        requiredFields: ['templateName', 'subject', 'htmlContent'],
        fieldOrder: ['templateName', 'subject', 'isActive', 'variables', 'htmlContent', 'createdAt', 'updatedAt'],
        fieldTypes: {
            templateName: 'string',
            subject: 'string',
            htmlContent: 'richtext',
            variables: 'array',
            isActive: 'boolean',
            createdAt: 'date',
            updatedAt: 'date'
        },
        fieldLabels: {
            templateName: 'Template Name',
            subject: 'Subject',
            htmlContent: 'HTML Content',
            variables: 'Variables',
            isActive: 'Is Active',
            createdAt: 'Created At',
            updatedAt: 'Updated At'
        }
    },
    // LearnWithAI - topics collection
    topics: {
        requiredFields: ['slug', 'displayName', 'category'],
        fieldOrder: ['slug', 'displayName', 'category', 'order'],
        fieldTypes: {
            slug: 'string',
            displayName: 'string',
            category: 'string',
            order: 'number',
        },
        fieldLabels: {
            slug: 'Slug',
            displayName: 'Display Name',
            category: 'Category',
            order: 'Sort Order',
        }
    },
    // LearnWithAI - concepts collection
    concepts: {
        requiredFields: ['topic', 'title', 'content'],
        fieldOrder: ['topic', 'type', 'title', 'content', 'explanation', 'examples'],
        fieldTypes: {
            topic: 'string',
            type: 'enum',
            title: 'string',
            content: 'string',
            explanation: 'string',
            examples: 'array',
        },
        fieldLabels: {
            topic: 'Topic Slug',
            type: 'Type',
            title: 'Title',
            content: 'Content',
            explanation: 'Explanation',
            examples: 'Examples',
        }
    },
    // LearnWithAI - questions collection
    questions: {
        requiredFields: ['topic', 'question', 'finalAnswer'],
        fieldOrder: ['topic', 'difficulty', 'question', 'solutionSteps', 'finalAnswer', 'conceptsUsed', 'source'],
        fieldTypes: {
            topic: 'string',
            question: 'string',
            solutionSteps: 'array',
            finalAnswer: 'string',
            conceptsUsed: 'array',
            difficulty: 'enum',
            source: 'string',
        },
        fieldLabels: {
            topic: 'Topic Slug',
            question: 'Question',
            solutionSteps: 'Solution Steps',
            finalAnswer: 'Final Answer',
            conceptsUsed: 'Concepts Used',
            difficulty: 'Difficulty',
            source: 'Source',
        }
    },
    // LearnWithAI - sessions collection (read-only user data)
    sessions: {
        requiredFields: ['userId', 'topic'],
        fieldOrder: ['userId', 'topic', 'messages', 'createdAt', 'updatedAt'],
        fieldTypes: {
            userId: 'string',
            topic: 'string',
            messages: 'array',
            createdAt: 'date',
            updatedAt: 'date',
        },
        fieldLabels: {
            userId: 'User ID',
            topic: 'Topic',
            messages: 'Messages',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
        }
    },
    // LearnWithAI - learning_items collection (read-only user data)
    learning_items: {
        requiredFields: ['userId', 'type', 'topic'],
        fieldOrder: ['userId', 'type', 'topic', 'selectedText', 'question', 'answer', 'front', 'back', 'confidence', 'questionId', 'isCorrect', 'createdAt'],
        fieldTypes: {
            userId: 'string',
            sessionId: 'string',
            type: 'enum',
            topic: 'string',
            selectedText: 'string',
            question: 'string',
            answer: 'string',
            front: 'string',
            back: 'string',
            confidence: 'number',
            questionId: 'string',
            isCorrect: 'boolean',
            createdAt: 'date',
        },
        fieldLabels: {
            userId: 'User ID',
            sessionId: 'Session ID',
            type: 'Type',
            topic: 'Topic',
            selectedText: 'Selected Text',
            question: 'Question',
            answer: 'Answer',
            front: 'Front (flashcard)',
            back: 'Back (flashcard)',
            confidence: 'Confidence (1-5)',
            questionId: 'Question ID',
            isCorrect: 'Is Correct',
            createdAt: 'Created At',
        }
    },
    // NewsRoomDb - Sources collection
    Sources: {
        requiredFields: ['name'],
        fieldOrder: ['name', 'type', 'categories', 'profiles', 'rss_feeds', 'avatar_url'],
        fieldTypes: {
            name: 'string',
            type: 'enum',
            categories: 'array',
            // profiles = array of { platform, url, handle }
            // e.g. [{"platform":"twitter","url":"https://x.com/realDonaldTrump","handle":"realDonaldTrump"},
            //        {"platform":"truthsocial","url":"https://truthsocial.com/@realDonaldTrump","handle":"realDonaldTrump"}]
            profiles: 'array',
            rss_feeds: 'array',
            avatar_url: 'string',
        },
        fieldLabels: {
            name: 'Name',
            type: 'Type (person/company/org)',
            categories: 'Categories (slugs)',
            profiles: 'Online Profiles (platform + url + handle)',
            rss_feeds: 'RSS Feed URLs',
            avatar_url: 'Avatar URL',
        }
    },
    // NewsRoomDb - Categories collection
    Categories: {
        requiredFields: ['slug', 'label'],
        fieldOrder: ['slug', 'label', 'icon', 'description', 'color', 'sort_order', 'active'],
        fieldTypes: {
            slug: 'string',
            label: 'string',
            icon: 'string',
            description: 'string',
            color: 'string',
            sort_order: 'number',
            active: 'boolean',
        },
        fieldLabels: {
            slug: 'Slug',
            label: 'Label',
            icon: 'Icon (emoji)',
            description: 'Description',
            color: 'Color (hex)',
            sort_order: 'Sort Order',
            active: 'Active',
        }
    },
    // NewsRoomDb - Topics collection
    Topics: {
        requiredFields: ['slug', 'label', 'category'],
        fieldOrder: ['slug', 'label', 'category', 'description', 'icon', 'keywords', 'search_query', 'sort_order', 'active'],
        fieldTypes: {
            slug: 'string',
            label: 'string',
            category: 'string',
            description: 'string',
            icon: 'string',
            keywords: 'array',
            search_query: 'string',
            sort_order: 'number',
            active: 'boolean',
        },
        fieldLabels: {
            slug: 'Slug',
            label: 'Label',
            category: 'Category Slug',
            description: 'Description',
            icon: 'Icon (emoji)',
            keywords: 'Keywords (for relevance filtering)',
            search_query: 'Gemini Search Query Override',
            sort_order: 'Sort Order',
            active: 'Active',
        }
    },
    // SocialMediaDb - Pictures collection
    Pictures: {
        requiredFields: ['title', 'awsLinks'],
        fieldOrder: ['title', 'description', 'awsLinks', 'dateOfPublish', 'createdAt'],
        fieldTypes: {
            title: 'string',
            description: 'richtext',
            awsLinks: 'array',
            dateOfPublish: 'date',
            createdAt: 'date'
        },
        fieldLabels: {
            title: 'Title',
            description: 'Description',
            awsLinks: 'AWS Links (1-20 URLs)',
            dateOfPublish: 'Publish Date',
            createdAt: 'Created At'
        }
    },
    // SocialMediaDb - ShortFormVideos (Reels) collection
    ShortFormVideos: {
        requiredFields: ['title', 'awsLink'],
        fieldOrder: ['title', 'description', 'awsLink', 'thumbnail', 'duration', 'dateOfPublish', 'createdAt'],
        fieldTypes: {
            title: 'string',
            description: 'richtext',
            awsLink: 'string',
            thumbnail: 'string',
            duration: 'string',
            dateOfPublish: 'date',
            createdAt: 'date'
        },
        fieldLabels: {
            title: 'Title',
            description: 'Description',
            awsLink: 'AWS Link (Reel Video)',
            thumbnail: 'Thumbnail URL',
            duration: 'Duration (e.g. 0:30)',
            dateOfPublish: 'Publish Date',
            createdAt: 'Created At'
        }
    },
    // SocialMediaDb - LongFormVideos (Videos) collection
    LongFormVideos: {
        requiredFields: ['title', 'awsLink'],
        fieldOrder: ['title', 'description', 'awsLink', 'thumbnail', 'duration', 'dateOfPublish', 'createdAt'],
        fieldTypes: {
            title: 'string',
            description: 'richtext',
            awsLink: 'string',
            thumbnail: 'string',
            duration: 'string',
            dateOfPublish: 'date',
            createdAt: 'date'
        },
        fieldLabels: {
            title: 'Title',
            description: 'Description',
            awsLink: 'AWS Link (Long Video)',
            thumbnail: 'Thumbnail URL',
            duration: 'Duration (e.g. 10:00)',
            dateOfPublish: 'Publish Date',
            createdAt: 'Created At'
        }
    },

    // AffiliateProductsDb - AffiliateProductDetails collection
    AffiliateProductDetails: {
        requiredFields: ['productName', 'productImages', 'productType', 'price', 'isPrivate', 'affiliateLink'],
        fieldOrder: ['productName', 'productType', 'price', 'isPrivate', 'affiliateLink', 'productImages', 'productDescription', 'createdAt'],
        fieldTypes: {
            productName: 'string',
            productImages: 'array',
            productType: 'array',
            price: 'number',
            isPrivate: 'boolean',
            productDescription: 'richtext',
            affiliateLink: 'string',
            createdAt: 'date'
        },
        fieldLabels: {
            productName: 'Product Name',
            productImages: 'Product Images (URLs)',
            productType: 'Product Type (Tags)',
            price: 'Price',
            isPrivate: 'Is Private',
            productDescription: 'Description',
            affiliateLink: 'Affiliate Link',
            createdAt: 'Created At'
        }
    },
};

// Helper function to get schema for a collection (case-insensitive and plural-aware)
export const getCollectionSchema = (collectionName) => {
    if (!collectionName) return null;
    
    // Exact match first
    if (COLLECTION_SCHEMAS[collectionName]) {
        return COLLECTION_SCHEMAS[collectionName];
    }
    
    // Case-insensitive and basic plural-aware match
    const lowerName = collectionName.toLowerCase();
    const key = Object.keys(COLLECTION_SCHEMAS).find(k => {
        const kLower = k.toLowerCase();
        // Match exact (case-insensitive) OR handle missing 's' at end OR handle extra 's' at end
        return kLower === lowerName || 
               kLower === lowerName + 's' || 
               lowerName === kLower + 's';
    });
    
    return key ? COLLECTION_SCHEMAS[key] : null;
};

// Helper function to check if a field is required
export const isFieldRequired = (collectionName, fieldName) => {
    const schema = getCollectionSchema(collectionName);
    if (!schema) return false;
    return schema.requiredFields.includes(fieldName);
};

// Helper function to get field type
export const getFieldType = (collectionName, fieldName) => {
    const schema = getCollectionSchema(collectionName);
    if (!schema) return 'string';
    return schema.fieldTypes[fieldName] || 'string';
};

// Helper function to get field label
export const getFieldLabel = (collectionName, fieldName) => {
    const schema = getCollectionSchema(collectionName);
    if (!schema) return fieldName;
    return schema.fieldLabels[fieldName] || fieldName;
};

// Helper function to get field order for a collection
export const getFieldOrder = (collectionName) => {
    const schema = getCollectionSchema(collectionName);
    if (!schema || !schema.fieldOrder) return null;
    return schema.fieldOrder;
};

// Helper function to validate required fields
export const validateRequiredFields = (collectionName, data) => {
    const schema = getCollectionSchema(collectionName);
    if (!schema) return { valid: true, errors: [] };
    
    // Ensure data is an object
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
        return { valid: false, errors: ['Invalid data format'] };
    }
    
    const errors = [];
    schema.requiredFields.forEach(field => {
        // Skip ID field validation for CouponCode - it's auto-generated
        if (collectionName === 'CouponCode' && field === 'id') {
            return; // Skip validation for ID field in CouponCode
        }
        // Skip passwordHash validation for Users - it's handled by backend
        if (collectionName === 'Users' && field === 'passwordHash') {
            return; // Skip validation for passwordHash field in Users
        }
        // Skip createdAt validation for BlogContent and date validation for PodcastsAudioDetails - they're auto-generated or handled by scheduling logic
        if ((collectionName === 'BlogContent' && field === 'createdAt') || 
            (collectionName === 'PodcastsAudioDetails' && field === 'date')) {
            return; // Skip validation
        }
        // Skip uploadedAt validation for ImageAssets - it's auto-generated by backend
        if (collectionName === 'ImageAssets' && field === 'uploadedAt') {
            return; // Skip validation for uploadedAt field in ImageAssets
        }
        // Skip createdAt/updatedAt validation for Regions - they're auto-generated
        if (collectionName === 'Regions' && (field === 'createdAt' || field === 'updatedAt')) {
            return;
        }
        // Skip createdAt/updatedAt validation for ProductPrices - they're auto-generated
        if (collectionName === 'ProductPrices' && (field === 'createdAt' || field === 'updatedAt')) {
            return;
        }
        const value = data[field];
        const fieldType = schema.fieldTypes[field];
        let isEmpty = false;
        
        // Check if value is empty based on type
        if (value === undefined || value === null) {
            isEmpty = true;
        } else if (fieldType === 'string' && (value === '' || (typeof value === 'string' && value.trim() === ''))) {
            isEmpty = true;
        } else if (fieldType === 'number' && (value === '' || value === null || isNaN(value))) {
            isEmpty = true;
        } else if (fieldType === 'array' && (!Array.isArray(value) || value.length === 0)) {
            isEmpty = true;
        } else if (fieldType === 'object' || fieldType === 'objectid') {
            if (typeof value === 'object' && value !== null) {
                if (Array.isArray(value) && value.length === 0) {
                    isEmpty = true;
                } else if (!Array.isArray(value) && Object.keys(value).length === 0) {
                    isEmpty = true;
                }
            } else if (value === '' || value === null || value === undefined) {
                isEmpty = true;
            }
        } else if (fieldType === 'boolean' && value === null) {
            isEmpty = true;
        } else if (fieldType === 'date' && (!value || value === '')) {
            isEmpty = true;
        }
        
        if (isEmpty) {
            errors.push(`${getFieldLabel(collectionName, field)} is required`);
        }
    });
    
    return {
        valid: errors.length === 0,
        errors
    };
};

